// PhonicsLt20.js
// 包装组件：Letter Teams L20
// 路由：/phonics/lt20
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt20 } from './phonics/phonics_data_lt20';

function PhonicsLt20() {
  return <PhonicsLt letterData={letterDataLt20} />;
}

export default PhonicsLt20;
